import { utils } from 'shared/intrasyncUtils';
import { makeAutoObservable } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";

class FabricationSequenceStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  get job() {
    const jobStore = this.rootStore.jobStore as ServiceStore;
    if (!jobStore) return null;
    const { entities } = jobStore;

    return entities.find((job) => {
      return utils.isSameJobNumber(
        job.jobNumber as string | number,
        this.jobNumber
      );
    });
  }

  get jobNumber() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) return "";
    const {
      params: { jobNumber },
    } = routerStore;

    return jobNumber as number;
  }

  get entities() {
    // console.log('this.jobNumber', this.jobNumber);
    const panelStore = this.rootStore.panelStore as ServiceStore;
    // const panelStore = this.rootStore.panelStore as ServiceStore;
    if (!panelStore?.entities?.length) return [];
    // console.log('panelStore.entities', panelStore.entities);
    return panelStore.entities
      .slice()
      .filter((panel) => {
        return (panel.jobNumber as number) === (this.jobNumber as number);
      })
      .map((panel) => {
        const foundPlantPanel = panelStore.entities.find(
          (plantPanel) =>
            plantPanel.controlNumber === panel.controlNumber &&
            plantPanel.jobNumber === panel.jobNumber
        );

        if (!foundPlantPanel) return panel;

        return {
          ...foundPlantPanel,
          ...panel,
        };
      });
  }
}

export default FabricationSequenceStore;
